import { actions } from './services';
import router from '@/modules/router/config';
import { CONSTANTS } from '@/constants/guide';

const getInitialState = () => {
  return {
    orphanPets: [],
    displayMode: 'home',
    loadOnVetQuit: false,
    intensiveCareProducts: [],
    intensiveCareProductPrices: [],
    intensiveCareProductTierPrices: [],
    windowWidth: 0,
    guidedTour: {},
    welcomeScreen: false
  };
};

//by default => initial state
const state = getInitialState();

const mutations = {
  stopTour: state => {
    state.guidedTour = {
      ...state.guidedTour,
      action: CONSTANTS.GUIDED_TOUR.ACTIONS.STOP_TOUR
    };
  },
  hideWelcomeScreen: (state, willContinue) => {
    state.welcomeScreen = false;
    if (!!!willContinue) {
      state.guidedTour = {
        ...state.guidedTour,
        action: CONSTANTS.GUIDED_TOUR.ACTIONS.STOP_TOUR
      };
    }
  },
  deactivateTour: state => {
    state.guidedTour = {
      ...state.guidedTour,
      action: CONSTANTS.GUIDED_TOUR.ACTIONS.NONE
    };
  },
  replayTour: state => {
    if (parseInt(state.guidedTour?.sections?.length) > 0) {
      state.guidedTour = {
        ...state.guidedTour,
        action: CONSTANTS.GUIDED_TOUR.ACTIONS.START_TOUR
      };
    }
  },
  previousTourStep: state => {
    state.guidedTour = {
      ...state.guidedTour,
      action: CONSTANTS.GUIDED_TOUR.ACTIONS.PREVIOUS_STEP
    };
  },
  nextTourStep: state => {
    state.guidedTour = {
      ...state.guidedTour,
      action: CONSTANTS.GUIDED_TOUR.ACTIONS.NEXT_STEP
    };
  },
  setOrphanPets: (state, payload) => {
    state.orphanPets = payload;
  },
  setTourData: (state, payload) => {
    if (
      router.currentRoute.name === 'Home' &&
      payload.action === 'START_TOUR'
    ) {
      state.welcomeScreen = true;
    }
    state.guidedTour = payload;
  },
  setDisplayMode: (state, payload) => {
    state.displayMode = payload;
  },
  deleteOrphanPet: (state, petId) => {
    state.orphanPets = state.orphanPets.filter(pet => pet.petId !== petId);
  },
  displayFloatingDots: state => {
    state.loadOnVetQuit = !!!state.loadOnVetQuit;
  },
  setIntensiveCareProducts: (state, payload) => {
    state.intensiveCareProducts = payload;
    state.intensiveCareProductPrices = {};
    state.intensiveCareProductTierPrices = {};
    for (const [key, value] of Object.entries(payload)) {
      state.intensiveCareProductPrices[key] = value.price;
      state.intensiveCareProductTierPrices[key] = value.tierPrice;
    }
  },
  setWindowWidth: (state, innerWidth) => {
    state.windowWidth = innerWidth;
  }
};
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
